module.exports = __webpack_public_path__ + "static/img/robot-img.9cf8ffa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/robot-img.png
// module id = kmbu
// module chunks = 1